export const TAXI_FIELD_KEYS = {
    TAXI_OPERATIONAL_NR: 'TaxiOperationalNr',
    TAXI_TRIP_NR: 'TaxiTripNr',
    TAXI_RECEIPT_NR: 'TaxiReceiptNr',
    TAXI_REFUND_AMOUNT: 'TaxiRefundAmount',
    TAXI_DRIVE_FROM: 'TaxiDriveFrom',
    TAXI_DRIVE_TO: 'TaxiDriveTo',
    MILEAGE_VEHICLE_REG_NR: 'MileageVehicleRegNr'
};

export const MILEAGE_FIELD_KEYS = {
    MILEAGE_DISTANCE: 'MileageDistance',
    MILEAGE_DRIVE_FROM: 'MileageDriveFrom',
    MILEAGE_DRIVE_TO: 'MileageDriveTo',
    MILEAGE_VEHICLE_REG_NR: 'MileageVehicleRegNr'
};

export const TRIP_FIELD_KEYS = {
    DATE: 'incidentDate',
    TIME: 'incidentTime',
    ROUTE_NR: 'routNumber',
    DRIVE_FROM: 'driveFrom',
    DRIVE_TO: 'driveTo',
    TERMINAL: 'terminal',
    TRANSPORT_TYPE: 'transportType'
};

export const OTHER_FIELD_KEYS = {
    OTHER_TRANSPORT_TYPE: 'OtherTransportType',
    OTHER_DRIVE_FROM: 'OtherDriveFrom',
    OTHER_DRIVE_TO: 'OtherDriveTo',
    OTHER_REFUND_AMOUNT: 'OtherRefundAmount'
};

export const BASE_FORM_VALUE_KEYS = {
    SYSTEM_INT32: 'System.Int32',
    DATE_TIME: 'DateTime',
    ACCOUNT_NR: 'AccountNr',
    COMPENSATION_TYPE: 'CompensationType',
    COMPENSATION_VALUE: 'CompensationType_value',
    OCCURRED_DATE: 'OccurredDate',
    FORM_TIME_ZONE: 'UTC'
};

export const MAX_ALLOWED_FILE_UPLOAD_COUNT = 10;
